/**
 * UI8 Forge Gate
 * Shared "is this thing actually on screen?" helper for the Forge animations
 * (forge-hearth.js, forge-flames.js).
 *
 * Why it exists: the mega-menu's Forge cell is laid out at all times and
 * hidden with opacity, not display —
 *
 *   .header__dropdown--browse  display: block; opacity: 0   (header.sass)
 *
 * so it never reports a zero-size box, and the animations happily
 * simulated, spawned SVG nodes and painted frames on every page of the site
 * from load until navigation, for visitors who never opened the menu.
 *
 * The reveal is driven entirely by class changes (a `.header__cell` gains
 * `active`/`active-touch` on hover/tap), so a
 * MutationObserver on that one class attribute tells us exactly when to run.
 * No polling, no per-frame getComputedStyle, no layout reads.
 *
 * Usage:
 *   var gate = window.ForgeGate.make(el);
 *   if (gate.isOpen()) start();
 *   gate.watch(function (open) { open ? start() : stop(); });
 *
 * Opt in per element with data-anim-gate="<body class>". With no attribute the
 * nearest .header__cell decides; with neither, the gate is always open (so an
 * instance dropped anywhere else keeps working).
 */
(function () {
  var ALWAYS = {
    isOpen: function () {
      return true;
    },
    watch: function () {},
  };

  // One observer per watched node, however many elements gate on it.
  var observers = [];

  function observe(node, notify) {
    for (var i = 0; i < observers.length; i++) {
      if (observers[i].node === node) {
        observers[i].subs.push(notify);
        return;
      }
    }
    var entry = { node: node, subs: [notify] };
    observers.push(entry);
    if (!window.MutationObserver) return;
    new MutationObserver(function () {
      for (var i = 0; i < entry.subs.length; i++) entry.subs[i]();
    }).observe(node, { attributes: true, attributeFilter: ["class"] });
  }

  function make(el) {
    var node, test;

    var bodyClass = el.getAttribute && el.getAttribute("data-anim-gate");
    if (bodyClass) {
      node = document.body;
      test = function () {
        return document.body.classList.contains(bodyClass);
      };
    } else {
      var cell = el.closest ? el.closest(".header__cell") : null;
      if (!cell) return ALWAYS;
      node = cell;
      // Mirrors header.sass: .active is the mouse path, .active-touch the tap
      // path. Either one reveals the dropdown.
      test = function () {
        return (
          cell.classList.contains("active") ||
          cell.classList.contains("active-touch")
        );
      };
    }

    return {
      isOpen: test,
      watch: function (cb) {
        var wasOpen = test();
        observe(node, function () {
          var open = test();
          if (open === wasOpen) return;
          wasOpen = open;
          cb(open);
        });
      },
    };
  }

  window.ForgeGate = { make: make };
})();
